import { render, staticRenderFns } from "./AbsenceAlert.vue?vue&type=template&id=ecf774c4"
import script from "./AbsenceAlert.vue?vue&type=script&lang=ts"
export * from "./AbsenceAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports